import React, { useState } from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Icon, SelectMenu } from '@scale/scaleui';
import { TextCollectionGPTOverrideVariableTypeSchemaMap } from '@scale/shared/pipelinev3/contentUnderstanding/paramsSchema';
import {
  TextCollectionGPTOverrideVariableType,
  TextCollectionGPTOverrideVariable,
} from '@scale/shared-types';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface TextCollectionGPTOverrideVariablesBuilderProps {
  name: string;
  existingValue?: Array<TextCollectionGPTOverrideVariable>;
  updateProperty: (arg: Array<TextCollectionGPTOverrideVariable> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const variableTypeOptions = [
  {
    id: TextCollectionGPTOverrideVariableType.ResponseField,
    name: 'Response Field',
  },
  {
    id: TextCollectionGPTOverrideVariableType.TemplateVariable,
    name: 'Task Template Variable',
  },
];

const TextCollectionGPTOverrideVariablesBuilder: React.FC<
  TextCollectionGPTOverrideVariablesBuilderProps
> = ({ name, existingValue = [], updateProperty, typeBuilderMap }) => {
  const variables = existingValue;
  const [selectedType, setSelectedType] = useState<TextCollectionGPTOverrideVariableType>(
    TextCollectionGPTOverrideVariableType.TemplateVariable,
  );

  const addVariable = (type: TextCollectionGPTOverrideVariableType) => {
    const newVariables = [...variables];
    newVariables.push({
      type,
      ...(type === TextCollectionGPTOverrideVariableType.TemplateVariable && {
        templateVariable: '',
      }),
      ...(type === TextCollectionGPTOverrideVariableType.ResponseField && {
        fieldId: '',
      }),
      variable: '',
    } as any);
    updateProperty(newVariables);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={variables}
        setElements={updateProperty}
        getKey={variable => JSON.stringify(variable)}
        getTitle={variable => `${variable.type}`}
        getSchema={variable => TextCollectionGPTOverrideVariableTypeSchemaMap[variable.type]}
      />
      <div className="flex">
        <SelectMenu
          className="min-w-[135px]"
          options={variableTypeOptions}
          selectedOptionId={selectedType}
          setSelected={value => {
            setSelectedType(value as TextCollectionGPTOverrideVariableType);
          }}
        />
        <Icon
          className="ml-4"
          hasBackground
          icon={['fas', 'plus']}
          onClick={() => addVariable(selectedType)}
          size="lg"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default TextCollectionGPTOverrideVariablesBuilder;
